import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const MobileBottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;

  if (!user) return null;

  const isActive = (path) => {
    if (path === '/matrimony/dashboard') return pathname === '/matrimony/dashboard' || pathname === '/dashboard';
    if (path === '/matrimony/search') return pathname.includes('/search');
    if (path === '/matrimony/matches') return pathname.includes('/matches') || pathname.includes('/interests');
    if (path === '/matrimony/profile') return pathname.includes('/profile');
    return false;
  };

  return (
    <div
      className="d-block d-md-none fixed-bottom bg-white border-top shadow-lg py-1 px-2"
      style={{ zIndex: 1040, borderTopColor: '#edf2f7' }}
    >
      <div className="d-flex align-items-center justify-content-around">
        {/* 1. Home */}
        <Link
          to="/matrimony/dashboard"
          className={`text-center text-decoration-none py-1 px-2 rounded-3 flex-fill ${isActive('/matrimony/dashboard') ? 'text-danger fw-bold' : 'text-secondary'
            }`}
          style={{ transition: 'color 0.2s ease-in-out' }}
        >
          <div style={{ fontSize: '1.25rem', lineHeight: '1.2' }}>
            <i className="fa fa-home"></i>
          </div>
          <div style={{ fontSize: '0.68rem', marginTop: '2px', fontWeight: isActive('/matrimony/dashboard') ? 700 : 500 }}>
            Home
          </div>
        </Link>

        {/* 2. Search Profile */}
        <Link
          to="/matrimony/search"
          className={`text-center text-decoration-none py-1 px-2 rounded-3 flex-fill ${isActive('/matrimony/search') ? 'text-danger fw-bold' : 'text-secondary'
            }`}
          style={{ transition: 'color 0.2s ease-in-out' }}
        >
          <div style={{ fontSize: '1.25rem', lineHeight: '1.2' }}>
            <i className="fa fa-search"></i>
          </div>
          <div style={{ fontSize: '0.68rem', marginTop: '2px', fontWeight: isActive('/matrimony/search') ? 700 : 500 }}>
            Search Profile
          </div>
        </Link>

        {/* 3. Match and Interest */}
        <Link
          to="/matrimony/matches"
          className={`text-center text-decoration-none py-1 px-2 rounded-3 flex-fill ${isActive('/matrimony/matches') ? 'text-danger fw-bold' : 'text-secondary'
            }`}
          style={{ transition: 'color 0.2s ease-in-out' }}
        >
          <div style={{ fontSize: '1.25rem', lineHeight: '1.2' }}>
            <i className="fa fa-heartbeat"></i>
          </div>
          <div style={{ fontSize: '0.68rem', marginTop: '2px', fontWeight: isActive('/matrimony/matches') ? 700 : 500 }}>
            Match & Interest
          </div>
        </Link>

        {/* 4. Profile */}
        <Link
          to="/matrimony/profile/me"
          className={`text-center text-decoration-none py-1 px-2 rounded-3 flex-fill ${isActive('/matrimony/profile') ? 'text-danger fw-bold' : 'text-secondary'
            }`}
          style={{ transition: 'color 0.2s ease-in-out' }}
        >
          <div style={{ fontSize: '1.25rem', lineHeight: '1.2' }}>
            <i className="fa fa-user-circle"></i>
          </div>
          <div style={{ fontSize: '0.68rem', marginTop: '2px', fontWeight: isActive('/matrimony/profile') ? 700 : 500 }}>
            Profile
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MobileBottomNav;
